export const GLOBAL_SEARCH_EVENTS = {
  event: 'event',
  searchOpen: 'searchOpen',
  historyClick: 'historyClick',
  actionClick: 'actionClick',
};

export const GLOBAL_SEARCH_GOOGLE_ANALYTICS_TAG = 'GlobalSearch';
